module.exports = __webpack_public_path__ + "static/img/phyto-res-what-makes-better-than-others.653ddf70.png";